import { Injectable } from '@angular/core';
import { EmployeeCategoryModel } from './model/employee-category.model';
import { RequestData } from 'src/app/common/models/request-data.model';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class EmployeeService {

  constructor(private http: HttpClient) { }

  getEmployeeList(requestData: RequestData): Observable<any> {
    return this.http.post(environment.baseUrl + '/hr/employees/list', requestData);
  }

  getEmployeeById(id: any): Observable<any> {
    return this.http.get(environment.baseUrl + '/hr/employees/' + id);
  }
  downloadExcel(requestData: any): Observable<Blob> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    return this.http.post(environment.baseUrl + '/wfm/employee/exportdatacsv', requestData, { headers, responseType: 'blob' });
  }

  update(employeeInfo: any): Observable<any> {
    if (employeeInfo.hasOwnProperty("id") && employeeInfo.id != 0) {
      return this.http.put(environment.baseUrl + '/hr/employees/' + employeeInfo.id, employeeInfo);
    } else {
      return this.http.post(environment.baseUrl + '/hr/employees', employeeInfo);
    }
  }

  delete(employeeInfo: any): Observable<any> {
    return this.http.delete(environment.baseUrl + '/hr/employees/' + employeeInfo.id);
  }

  getDepartmentList(requestData: any): Observable<any> {
    return this.http.post(environment.baseUrl + '/wfm/department/get', requestData);
  }

  getEmployeeCategoryList(requestData: RequestData): Observable<any> {
    return this.http.post(environment.baseUrl + '/wfm/employeecategory/get', requestData);
  }

  getShopEmployeeMapping(employeeId: number): Observable<any> {
    return this.http.post(`${environment.baseUrl}/wfm/employee/shop-employee-mapping/${employeeId}`, {});
  }

  getEmployeeStatusesList(requestData: RequestData): Observable<any> {
    return this.http.post(environment.baseUrl + '/hr/employee-statuses/list', requestData);
  }
}
